module.exports = __webpack_public_path__ + "static/media/IMG_4395.f8d688a2.JPG";